{
  "familyId": "MET-LEN-SCHATTEN",
  "questions": [
    {
      "id": "MET-LEN-SCHATTEN-001",
      "familyId": "MET-LEN-SCHATTEN",
      "module": "Metriek",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "lengte",
      "subSkill": "lengte_schatten",
      "questionType": "multiple_choice",
      "question": "Een bouwvakker schat dat een deuropening 5 meter hoog is. Zijn collega zegt: \"Dat kan niet kloppen.\" Waarom heeft de collega gelijk?",
      "context": null,
      "options": ["Een deur is ongeveer 2 meter hoog, dus 5 meter is veel te hoog", "Een deur is ongeveer 50 cm hoog", "5 meter is precies goed voor een deur", "Een deur is ongeveer 20 meter hoog"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "ruler",
          "showWhen": "wrong",
          "data": {
            "length": 15,
            "objectStart": 0,
            "objectEnd": 12,
            "unit": "cm",
            "label": "Een liniaal helpt je schatten. 12 cm op de liniaal = de breedte van je hand."
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Referentiepunten voor lengte",
            "content": "Gebruik bekende voorwerpen als referentie:\n• Pink breed ≈ 1 cm\n• Arm ≈ 50 cm\n• Deur ≈ 2 m\n• Verdieping ≈ 3 m\n• Voetbalveld ≈ 100 m",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "lengte_schatten_deur",
      "variantIndex": 1,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.79,
      "feedback": {
        "explanationText": "De collega heeft gelijk. Een deur is ongeveer 2 meter hoog — iets hoger dan een volwassene. 5 meter is hoger dan een hele verdieping (≈3 m). Waarom is schatten belangrijk? Omdat je zo snel kunt controleren of een meting logisch is. Een bouwvakker die 5 meter opschrijft, weet meteen dat er iets fout is.",
        "solutionSteps": [
          "Gebruik een referentiepunt: een deur is een bekend voorwerp",
          "Een deur is ongeveer 2 meter hoog (iets hoger dan een volwassene)",
          "Beoordeel de schatting: 5 m > 3 m (een verdieping) → veel te hoog",
          "Conclusie: de collega heeft gelijk ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Een deur is ongeveer 2 meter hoog. 5 meter is veel te hoog — dat is hoger dan een hele verdieping.",
          "1": "Je dacht waarschijnlijk dat een deur heel klein is. Maar 50 cm is de hoogte van een klein tafeltje. Een deur is veel hoger: ongeveer 2 meter. Onthoud: deur ≈ 2 m.",
          "2": "Je dacht waarschijnlijk dat 5 meter klopt. Maar 5 meter is hoger dan een verdieping (≈3 m). Geen enkele standaard deur is zo hoog. Onthoud: deur ≈ 2 m.",
          "3": "Je dacht waarschijnlijk dat een deur 20 meter hoog is. Maar 20 meter is de hoogte van een flatgebouw van 6 verdiepingen! Onthoud: deur ≈ 2 m."
        }
      }
    },
    {
      "id": "MET-LEN-SCHATTEN-002",
      "familyId": "MET-LEN-SCHATTEN",
      "module": "Metriek",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "lengte",
      "subSkill": "lengte_schatten",
      "questionType": "multiple_choice",
      "question": "Een leerling meet zijn potlood en schrijft het resultaat op. Welke eenheid heeft hij waarschijnlijk gebruikt?",
      "context": null,
      "options": ["Meter", "Millimeter", "Centimeter", "Kilometer"],
      "correctAnswer": 2,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Welke eenheid waarvoor?",
            "content": "Kies de eenheid die het handigste getal geeft:\n• Millimeter = heel klein (dikte munt)\n• Centimeter = kleine voorwerpen (potlood, boek)\n• Meter = grote voorwerpen (kamer, auto)\n• Kilometer = afstanden (stad naar stad)",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "lengte_schatten_eenheid",
      "variantIndex": 2,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Een potlood is ongeveer 15-20 centimeter lang. Centimeter is de juiste eenheid voor kleine voorwerpen. Waarom niet millimeter? Dat kan (~180 mm), maar centimeter geeft een handiger getal. Waarom niet meter? Een potlood is ~0,18 m — een onhandig kommagetal.",
        "solutionSteps": [
          "Schat de lengte van een potlood: ~15-20 cm",
          "Beoordeel elke eenheid: cm geeft een handig getal (15-20)",
          "Millimeter zou ~180 mm zijn — kan, maar onhandig",
          "Meter zou ~0,18 m zijn — onhandig kommagetal"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk aan meters. Maar een potlood is ~0,18 meter — een onhandig kommagetal. Onthoud: meter gebruik je voor grote dingen (kamer, auto).",
          "1": "Je dacht waarschijnlijk aan millimeters. Dat kan (~180 mm), maar centimeter is handiger en gebruikelijker voor voorwerpen van deze grootte. Onthoud: cm = kleine voorwerpen.",
          "2": "Goed! Een potlood meet je in centimeters (~15-20 cm). Dat geeft het handigste getal.",
          "3": "Je dacht waarschijnlijk aan kilometers. Maar kilometer gebruik je voor afstanden tussen steden, niet voor een potlood. Een potlood is ~0,00018 km — absurd klein getal!"
        }
      }
    },
    {
      "id": "MET-LEN-SCHATTEN-003",
      "familyId": "MET-LEN-SCHATTEN",
      "module": "Metriek",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "lengte",
      "subSkill": "lengte_schatten",
      "questionType": "multiple_choice",
      "question": "De afstand van Amsterdam naar Utrecht is ongeveer 40 km. Welk voorwerp is ongeveer 1 kilometer lang?",
      "context": null,
      "options": ["Een schoolplein", "10 voetbalvelden achter elkaar", "Een klaslokaal", "Een zwembad"],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "ruler",
          "showWhen": "wrong",
          "data": {
            "length": 15,
            "objectStart": 0,
            "objectEnd": 10,
            "unit": "cm",
            "label": "10 voetbalvelden (elk ~100 m) = 1 km. Gebruik bekende lengtes als referentie."
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Hoe lang is 1 kilometer?",
            "content": "1 kilometer = 1.000 meter.\nEen voetbalveld is ~100 meter lang.\nDus 10 voetbalvelden achter elkaar ≈ 1 km.\nAls je stevig doorloopt, doe je er ~12 minuten over.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "lengte_schatten_kilometer",
      "variantIndex": 3,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "1 kilometer = 1.000 meter. Een voetbalveld is ~100 meter lang, dus 10 voetbalvelden achter elkaar is ~1.000 meter = 1 km. Waarom is dit een handig referentiepunt? Omdat je een voetbalveld goed kunt voorstellen — en 10 daarvan geeft je een gevoel voor hoe lang 1 km is.",
        "solutionSteps": [
          "Onthoud: 1 km = 1.000 m",
          "Een voetbalveld is ~100 m lang",
          "Bereken: 10 × 100 m = 1.000 m = 1 km",
          "Controleer de andere opties: schoolplein (~50-100 m), klaslokaal (~10 m), zwembad (~50 m) — allemaal veel korter ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat een schoolplein 1 km lang is. Maar een schoolplein is ~50-100 meter, veel korter dan 1 km (1.000 m). Onthoud: 1 km = 10 voetbalvelden.",
          "1": "Goed! 10 voetbalvelden ≈ 1 kilometer. Een handig referentiepunt om te onthouden.",
          "2": "Je dacht waarschijnlijk dat een klaslokaal 1 km lang is. Maar een klaslokaal is ~8-10 meter — je hebt er 100 nodig voor 1 km! Onthoud: klaslokaal ≈ 10 m.",
          "3": "Je dacht waarschijnlijk dat een zwembad 1 km lang is. Maar een zwembad is 25 of 50 meter. Je zou 20-40 zwembaden nodig hebben voor 1 km. Onthoud: zwembad ≈ 50 m."
        }
      }
    },
    {
      "id": "MET-LEN-SCHATTEN-004",
      "familyId": "MET-LEN-SCHATTEN",
      "module": "Metriek",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "lengte",
      "subSkill": "lengte_schatten",
      "questionType": "multiple_choice",
      "question": "Een leerling zegt: \"Mijn duim is 1 centimeter breed.\" De juf zegt: \"Bijna goed, maar er is een beter referentiepunt.\" Welk lichaamsdeel is precies ongeveer 1 centimeter breed?",
      "context": null,
      "options": ["Je voetbal", "Je tafel", "Je boek", "Je pinknagel"],
      "correctAnswer": 3,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "ruler",
          "showWhen": "wrong",
          "data": {
            "length": 5,
            "objectStart": 0,
            "objectEnd": 1,
            "unit": "cm",
            "label": "Je pinknagel is ~1 cm breed. Meet het na op deze liniaal!"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Hoe groot is 1 centimeter?",
            "content": "Handige referentiepunten voor je lichaam:\n• Pinknagel ≈ 1 cm breed\n• Duim ≈ 2 cm breed\n• Hand (gespreid) ≈ 20 cm\nZo heb je altijd een 'meetlat' bij je!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "lengte_schatten_centimeter",
      "variantIndex": 4,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.77,
      "feedback": {
        "explanationText": "Je pinknagel is het beste referentiepunt voor 1 cm. Een duim is ~2 cm breed, dus de leerling zit er een beetje naast. Waarom is dit handig? Omdat je je pinknagel altijd bij je hebt — zo kun je overal schatten zonder liniaal. Referentiepunten: pink = 1 cm, duim = 2 cm, hand = 20 cm.",
        "solutionSteps": [
          "Beoordeel de bewering: een duim is ~2 cm, niet 1 cm",
          "Zoek een beter referentiepunt voor 1 cm",
          "Je pinknagel is ~1 cm breed ✓",
          "Controleer: voetbal (~22 cm), tafel (~120 cm), boek (~25 cm) — allemaal veel groter"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk aan een voetbal. Maar een voetbal heeft een doorsnede van ~22 cm — veel groter dan 1 cm. Onthoud: pinknagel ≈ 1 cm.",
          "1": "Je dacht waarschijnlijk aan een tafel. Maar een tafel is ~80-120 cm breed — veel groter dan 1 cm. Onthoud: pinknagel ≈ 1 cm.",
          "2": "Je dacht waarschijnlijk aan een boek. Maar een boek is ~15-25 cm breed — veel groter dan 1 cm. Onthoud: pinknagel ≈ 1 cm.",
          "3": "Goed! Je pinknagel is ~1 cm breed. Dit is een handig referentiepunt dat je altijd bij je hebt."
        }
      }
    },
    {
      "id": "MET-LEN-SCHATTEN-005",
      "familyId": "MET-LEN-SCHATTEN",
      "module": "Metriek",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "lengte",
      "subSkill": "lengte_schatten",
      "questionType": "multiple_choice",
      "question": "Een leerling zet voorwerpen op volgorde van lengte, maar maakt een fout: \"Potlood, paperclip, tafel, auto, voetbalveld.\" Wat moet hij veranderen?",
      "context": null,
      "options": ["De volgorde klopt al", "Tafel en auto omdraaien", "Paperclip en potlood omdraaien, want een paperclip is korter", "Voetbalveld moet vooraan staan"],
      "correctAnswer": 2,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "ruler",
          "showWhen": "wrong",
          "data": {
            "length": 20,
            "objectStart": 0,
            "objectEnd": 18,
            "unit": "cm",
            "label": "Een potlood is ~18 cm. Een paperclip is ~3 cm. Vergelijk op de liniaal."
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Lengtes van bekende voorwerpen",
            "content": "Paperclip ≈ 3 cm\nPotlood ≈ 18 cm\nTafel ≈ 1,5 m\nAuto ≈ 4 m\nVoetbalveld ≈ 100 m\nVan kort naar lang: paperclip → potlood → tafel → auto → voetbalveld",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "lengte_schatten_volgorde",
      "variantIndex": 5,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "De fout zit bij de eerste twee. Een paperclip is ~3 cm en een potlood is ~18 cm. De paperclip moet dus vóór het potlood. De rest klopt: tafel (~1,5 m), auto (~4 m), voetbalveld (~100 m). Waarom is dit een goede oefening? Omdat je leert om lengtes te vergelijken met referentiepunten.",
        "solutionSteps": [
          "Controleer de volgorde van de leerling: potlood, paperclip, tafel, auto, voetbalveld",
          "Schat de lengtes: paperclip (~3 cm) is korter dan potlood (~18 cm)",
          "De leerling heeft ze omgedraaid — paperclip moet eerst",
          "Juiste volgorde: paperclip → potlood → tafel → auto → voetbalveld ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat de volgorde al klopt. Maar de paperclip (~3 cm) staat na het potlood (~18 cm) — dat is van groot naar klein. Onthoud: paperclip < potlood.",
          "1": "Je dacht waarschijnlijk dat tafel en auto omgedraaid moeten. Maar een tafel (~1,5 m) is korter dan een auto (~4 m) — die volgorde klopt. De fout zit bij paperclip en potlood.",
          "2": "Goed! Een paperclip (~3 cm) is korter dan een potlood (~18 cm). Die twee moeten omgedraaid worden.",
          "3": "Je dacht waarschijnlijk dat de volgorde omgekeerd moet. Maar de vraag is van kort naar lang. Het voetbalveld (~100 m) is het langst en hoort achteraan."
        }
      }
    },
    {
      "id": "MET-LEN-SCHATTEN-006",
      "familyId": "MET-LEN-SCHATTEN",
      "module": "Metriek",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "lengte",
      "subSkill": "lengte_schatten",
      "questionType": "estimation_slider",
      "question": "Schat hoe hoog een deuropening is in centimeters.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "min": 0,
        "max": 500,
        "correctValue": 200,
        "tolerancePercent": 12,
        "unit": "cm",
        "showNumberLine": true,
        "showValue": false
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "ruler",
          "showWhen": "wrong",
          "data": {
            "length": 15,
            "objectStart": 0,
            "objectEnd": 12,
            "unit": "cm",
            "label": "Een deur is ~200 cm (2 meter) hoog — iets hoger dan een volwassene."
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Referentiepunten voor lengte",
            "content": "Gebruik bekende voorwerpen als referentie:\n• Pink breed ≈ 1 cm\n• Arm ≈ 50 cm\n• Deur ≈ 200 cm (2 m)\n• Verdieping ≈ 300 cm (3 m)\n• Voetbalveld ≈ 10.000 cm (100 m)",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "lengte_schatten_deur_slider",
      "variantIndex": 6,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Een deuropening is ongeveer 200 cm (2 meter) hoog. Dat is iets hoger dan een volwassene (~175 cm). Hoe schat je dit? Denk aan jezelf: als je door een deur loopt, heb je nog ruimte boven je hoofd. Een volwassene + ~25 cm = ~200 cm.",
        "solutionSteps": [
          "Referentie: een volwassene is ~175 cm",
          "Een deur is iets hoger dan een volwassene",
          "Schatting: ~200 cm (2 meter)",
          "Check: 200 cm = 2 m, dat klinkt realistisch ✓"
        ]
      }
    },
    {
      "id": "MET-LEN-SCHATTEN-007",
      "familyId": "MET-LEN-SCHATTEN",
      "module": "Metriek",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "lengte",
      "subSkill": "lengte_schatten",
      "questionType": "estimation_slider",
      "question": "Schat hoe lang een voetbalveld is in meters.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "min": 0,
        "max": 200,
        "correctValue": 100,
        "tolerancePercent": 12,
        "unit": "m",
        "showNumberLine": true,
        "showValue": false
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "ruler",
          "showWhen": "wrong",
          "data": {
            "length": 15,
            "objectStart": 0,
            "objectEnd": 10,
            "unit": "cm",
            "label": "Een voetbalveld is ~100 meter lang. 10 voetbalvelden = 1 kilometer."
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Hoe lang is een voetbalveld?",
            "content": "Een voetbalveld is ~100 meter lang en ~70 meter breed.\nDat is 10× de lengte van een klaslokaal (~10 m).\nAls je hard rent, doe je er ~12 seconden over.\n10 voetbalvelden achter elkaar = 1 kilometer.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "lengte_schatten_voetbalveld_slider",
      "variantIndex": 7,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.77,
      "feedback": {
        "explanationText": "Een voetbalveld is ongeveer 100 meter lang. Hoe schat je dit? Denk aan een klaslokaal (~10 m). Een voetbalveld is 10 klaslokalen achter elkaar. Of: als je hard rent, doe je er ~12 seconden over.",
        "solutionSteps": [
          "Referentie: een klaslokaal is ~10 meter",
          "Een voetbalveld = ~10 klaslokalen lang",
          "Schatting: 10 × 10 = ~100 meter",
          "Check: 10 voetbalvelden = 1 km ✓"
        ]
      }
    }
  ]
}